/**
 * Match a filename against a filter pattern.
 * Plain text → case-insensitive substring match.
 * Contains `*` or `?` → glob match.
 */
export function matchesFilter(name: string, pattern: string): boolean {
  if (!pattern) return true;
  if (pattern.includes('*') || pattern.includes('?')) {
    const escaped = pattern
      .replace(/[.+^${}()|[\]\\]/g, '\\$&')
      .replace(/\*\*/g, '\u2318GLOBSTAR\u2318')
      .replace(/\*/g, '[^/]*')
      .replace(/\u2318GLOBSTAR\u2318/g, '.*')
      .replace(/\?/g, '.');
    return new RegExp(`^${escaped}$`, 'i').test(name);
  }
  return name.toLowerCase().includes(pattern.toLowerCase());
}

/** PCS-578: shared formatter for any metric value rendered to the user.
 *  Every surface that shows `metric_specs[*].baseline` (landing card,
 *  project picker, admin table, eval gauge) MUST go through this so
 *  `0.7` and `0.70` never render as different strings. */
export function formatMetric(n: number | null | undefined): string {
  if (n == null || !Number.isFinite(n)) return '—';
  return n.toFixed(2);
}

/** Human-readable byte size. Scales from bytes through TB. */
export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 ** 2) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 ** 3) return `${(bytes / 1024 ** 2).toFixed(1)} MB`;
  if (bytes < 1024 ** 4) return `${(bytes / 1024 ** 3).toFixed(2)} GB`;
  return `${(bytes / 1024 ** 4).toFixed(2)} TB`;
}
